import { ReactNode } from 'react';
import classes from './PageTitle.module.css';

const PageTitle = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <h1 className={`${classes.title} ${className}`}>{children}</h1>
);

export default PageTitle;
